import 'react';

const If = ({ condition, otherwise = null, children }) => condition ? children : otherwise;

export { If };
